import React from "react";
import "./info.css";
import { Fade } from "react-awesome-reveal";
import img from "../../images/undraw_learning_re_32qv.svg";
const Info = () => {
  return (
    <div id="important">
      <section className="info">
        <h3 className="tit text-center">اهم المميزات </h3>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <Fade direction="right" triggerOnce="false">
                <img src={img} className="img-responsive" alt="feature img" />
              </Fade>
            </div>
            <div className="col-md-6 ">
              <Fade direction="left" triggerOnce="false">
                <h2 className="text-uppercase">VIP لتسهيل الخدمات</h2>
                <p>
                  متخصصين في تقديم كافة الخدمات من استيراد السيارات وخدمات
                  السياحة من حجز تذاكر الطيران والأقامة وغيراها وكافة خدمات
                  الشهر العقاري من اعمال توكيلات واعمال تحرير وتوثيق وخدمات
                  المحليات والتي تشمل خدمات البناء والأراضي والمصاعد والأشغالات
                  وخدمات المحلات التجارية وخدمات الأعلانات وخدمات اخرى وايضاً
                  جميع خدمات المرور من استخراج رخصة وتجديد وبدل فاقد للأفراد
                  وللمركبات وتخليص المعاملات بأنواعها من خدمات الكهرباء والغاز
                </p>
              </Fade>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Info;
